<template>
    <NuxtLink
        v-if="test"
        class="link inline-flex items-center gap-1 text-sm font-semibold"
        target="_blank"
        :to="`/sebapoznanie/${test.slug}`"
    >
        {{ label }}
    </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { recommendTestForJob } from '#shared/sebapoznanie/jobFit'
import type { JobWorkProfile } from '#shared/types/Job'
import type { SurveyTypes } from '#shared/types/Survey'
import { useSebapoznanieTests } from '@/composables/useSebapoznanieTests'

const props = defineProps<{
    workProfile?: JobWorkProfile | null
    /** Tests the candidate already has a shareable result from */
    doneTypes: SurveyTypes[]
}>()

const { getTestBySurveyType } = useSebapoznanieTests()

const test = computed(() => {
    const type = recommendTestForJob(props.workProfile, props.doneTypes)
    return type ? getTestBySurveyType(type) : undefined
})

const label = computed(() =>
    test.value
        ? `${props.doneTypes.length ? 'Doplň test' : 'Začni testom'} ${test.value.title} (${test.value.duration}) →`
        : ''
)
</script>
